
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import draggable from "vuedraggable";
import { ElementStudioContext } from "@/components/ElementStudio/ElementStudioTabsAndPanels.vue";
import Accordion from "@/components/UI/Accordion.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import defensiveCopy from "@/util/defensive-copy";
import CodeInput from "@/components/Reusable/CustomInputs/CodeInput/CodeInput.vue";
import { inputTextValidationRules } from "@/util/input-text-validation-rules";
import { BuilderElementAdditionalClasses } from "@/types/elements";

@Component({
  components: {
    CodeInput,
    Repeater,
    Dropdown,
    Accordion,
    draggable
  }
})
export default class ElementStudioAdditionalClasses extends Vue {
  @Prop({ default: [] })
  value!: BuilderElementAdditionalClasses;

  @Inject("context") readonly context!: ElementStudioContext;

  updateClasses(newValue: BuilderElementAdditionalClasses) {
    this.$emit("input", newValue);
  }

  updateName(index: number, newClassName: string) {
    const newValue = defensiveCopy(this.value);

    if (this.htmlClassNameRule(newClassName) !== true) return;

    newValue[index].name = newClassName.trim();
    this.$emit("input", newValue);
  }

  updateValue(index: number, newTemplate: string | null) {
    const newValue = defensiveCopy(this.value);

    newValue[index].template = newTemplate ?? "";
    this.$emit("input", newValue);
  }

  htmlClassNameRule(value: string | undefined) {
    return inputTextValidationRules.validateHtmlClassName(value);
  }
}
